import { useQuery } from "@tanstack/react-query";
import { accountManagerApi } from "../api/accountManagerApi";
import { queryKeys } from "../../../api/queryKeys";

export const useAMCustomers = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.accountManager.customers(),
    queryFn: () => accountManagerApi.customers.list(),
    enabled: options?.enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
